import React, { useState } from 'react';
import Modal from './Modal';
import ReusableTable from './ReusableTable';
import CreateButton from './CreateButton';
import EditButton from './EditButton';
import DeleteButton from './DeleteButton';
import './styles/components.css';

const ViewButton = ({
  onView,
  columns,
  formConfig,
  onCreate,
  onEdit,
  onDelete,
  subViewButtonProps // para recursividad
}) => {
  const [open, setOpen] = useState(false);
  const [detalle, setDetalle] = useState([]);
  const [loading, setLoading] = useState(false);

  // Refresca los datos del detalle
  const fetchDetalle = async () => {
    setLoading(true);
    try {
      const data = await onView();
      setDetalle(data);
    } catch {
      setDetalle([]);
    }
    setLoading(false);
  };

  const handleOpen = async () => {
    await fetchDetalle();
    setOpen(true);
  };

  // Handlers para refrescar después de crear/editar/eliminar
  const handleCreate = async (values, onDone) => {
    if (!onCreate) return;
    await onCreate(values, async success => {
      if (success) await fetchDetalle();
      onDone(success);
    });
  };

  const handleEdit = async (row, values, onDone) => {
    if (!onEdit) return;
    await onEdit(row, values, async success => {
      if (success) await fetchDetalle();
      onDone(success);
    });
  };

  const handleDelete = async (row, onDone) => {
    if (!onDelete) return;
    await onDelete(row, async success => {
      if (success) await fetchDetalle();
      onDone(success);
    });
  };

  // Renderiza acciones para cada fila del detalle
  const actionRender = row => (
    <>
      {onEdit && (
        <EditButton
          item={row}
          formConfig={formConfig}
          onEdit={(values, onDone) => handleEdit(row, values, onDone)}
        />
      )}
      {subViewButtonProps && (
        <ViewButton
          {...subViewButtonProps}
          onView={() => subViewButtonProps.onView(row)}
        />
      )}
      {onDelete && (
        <DeleteButton
          item={row}
          onDelete={onDone => handleDelete(row, onDone)}
        />
      )}
    </>
  );

  return (
    <>
      <button className="view-btn" onClick={handleOpen} title="Ver detalles">
        Ver
      </button>
      {open && (
        <Modal
          title="Detalle"
          onClose={() => setOpen(false)}
          actions={
            <div className="modal-actions">
              <button type="button" className="close-btn" onClick={() => setOpen(false)}>
                Cerrar
              </button>
            </div>
          }
        >
          {loading ? (
            <div>Cargando...</div>
          ) : (
            <>
              {onCreate && (
                <div style={{ overflow: 'hidden' }}>
                  <CreateButton formConfig={formConfig} onCreate={handleCreate} />
                </div>
              )}
              {Array.isArray(detalle) && detalle.length > 0 ? (
                <ReusableTable
                  data={detalle}
                  columns={columns}
                  actionRender={onEdit || onDelete || subViewButtonProps ? actionRender : undefined}
                />
              ) : (
                <div style={{ padding: '1rem', color: '#888' }}>
                  No hay objetos para mostrar
                </div>
              )}
            </>
          )}
        </Modal>
      )}
    </>
  );
};

export default ViewButton;
